function getLibelleData() {
  if (window.location.origin.indexOf(':9000') >= 0 || window.location.origin.indexOf('slots-ux') >= 0) {
    // eslint-disable-next-line global-require
    return require('../../static/json/libelle.json');
  }

  let libelleData = null;

  jQuery.ajax({
    url: '/static/json/libelle.json',
    cache: true,
    async: false,
    dataType: 'json',
    success: (json) => {
      libelleData = json;
    }
  });

  return libelleData;
}

function changeBackgroundColorEvery(timeInterval, repeatCount, $node, color1, color2) {
  let backgroundColor = color1;
  $node.css('background-color', backgroundColor);

  if (color2) {
    let iteration = 0;

    const changingColorInterval = setInterval(() => {
      backgroundColor = iteration % 2 === 0 ? color2 : color1;
      $node.css('background-color', backgroundColor);
      iteration += 1;
    }, timeInterval);

    setTimeout(() => {
      clearInterval(changingColorInterval);
    }, timeInterval * repeatCount);
  }
}

function changeText($node, textDesktop, textMobile) {
  const deviceText = (jQuery(window).width() > 800) ? textDesktop : textMobile;

  if (deviceText) {
    $node.html(deviceText);
  }
}

export { getLibelleData, changeBackgroundColorEvery, changeText };



// WEBPACK FOOTER //
// ./src/_override/shared/libelle/libelle-functions.js